export default __webpack_public_path__ + "static/media/10.54e0d4e1.svg";